import api from '@shared/services/api';
import { useEffect, useState } from 'react';

interface TopTester {
  userId: string;
  name: string;
  thumbnailUrl: string | null;
  testsCompleted: number;
  correctAnswers: number;
  incorrectAnswers: number;
  totalScore: number;
}

export const useTopTesters = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [topTesters, setTopTesters] = useState<TopTester[]>([]);

  useEffect(() => {
    const fetchTopTesters = async () => {
      try {
        setLoading(true);
        const response = await api.get<{
          status: string;
          data: TopTester[];
        }>('/analytics/top-testers');
        setTopTesters(response.data.data);
        setError(null);
      } catch (err) {
        setError('Failed to fetch top testers');
        console.error('Error fetching top testers:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTopTesters();
  }, []);

  return { loading, error, topTesters };
};
